'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropDownMenu = require('common/components/drop-down-menu');

var _dropDownMenu2 = _interopRequireDefault(_dropDownMenu);

var _loginButton = require('./login-button');

var _loginButton2 = _interopRequireDefault(_loginButton);

var _signupButton = require('./signup-button');

var _signupButton2 = _interopRequireDefault(_signupButton);

var _topBarMenuLink = require('./top-bar-menu-link');

var _topBarMenuLink2 = _interopRequireDefault(_topBarMenuLink);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _topBarV = require('./experiments/top-bar-v2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TopBarMenu = _react2['default'].createClass({
    displayName: 'TopBarMenu',


    propTypes: {
        'topBarMenuLinkData': _react2['default'].PropTypes.array.isRequired,
        'dropDownMenuLinkData': _react2['default'].PropTypes.array.isRequired,
        'pageToHighLight': _react2['default'].PropTypes.string,
        'useWhite': _react2['default'].PropTypes.bool,
        'useBlack': _react2['default'].PropTypes.bool,
        'isCompact': _react2['default'].PropTypes.bool,
        'isLogInButtonVisible': _react2['default'].PropTypes.bool,
        'isSignUpButtonVisible': _react2['default'].PropTypes.bool,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'loginEmailAddress': _react2['default'].PropTypes.string,
        'loginTargetUrl': _react2['default'].PropTypes.string,
        'signupTargetUrl': _react2['default'].PropTypes.string,
        'useRegularLink': _react2['default'].PropTypes.bool,
        'loginHeaderText': _react2['default'].PropTypes.string,
        'recaptchaPublicKey': _react2['default'].PropTypes.string,
        'displayCaptcha': _react2['default'].PropTypes.bool,
        'hideDropDownMenu': _react2['default'].PropTypes.bool,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'signupForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
    },

    getInitialState: function getInitialState() {
        return {
            'menuOpen': false
        };
    },
    toggleMenu: function toggleMenu() {
        this.setState({
            'menuOpen': !this.state.menuOpen
        });
    },
    componentDidMount: function componentDidMount() {
        var container = $('.google-collapse');
        $(document).click(function (e) {
            if (container.html() != $(e.target).parent().parent().html()) {
                if (this.state.menuOpen) {
                    this.setState({
                        'menuOpen': false
                    });
                }
            }
        }.bind(this));
    },
    openMenu: function openMenu() {
        this.setState({
            'menuOpen': true
        });
    },
    setStateMousedOverDropDownMenuTrue: function setStateMousedOverDropDownMenuTrue() {
        this.setState({
            'mousedOverDropDownMenu': true
        });
    },
    setStateMousedOverDropDownMenuFalse: function setStateMousedOverDropDownMenuFalse() {
        this.setState({
            'mousedOverDropDownMenu': false
        });
    },
    closeMenu: function closeMenu() {
        var self = this;
        window.setTimeout(function () {
            if (self.state.mousedOverDropDownMenu !== true) {
                self.setState({
                    'menuOpen': false
                });
            }
        }, 200);
    },
    shouldRenderV2experiement: function shouldRenderV2experiement() {
        // Use v2 for desktop, and v1 for devices with view widths lower than threshold
        return window.innerWidth >= _topBarV.TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD;
    },
    render: function render() {

        var topBarMenuLinkDataSource = this.props.topBarMenuLinkData;

        if (this.shouldRenderV2experiement()) {
            Cookie.set(_topBarV.TOP_BAR_V2_EXPERIMENT_COOKIE_NAME, _topBarV.TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE);
            return this.renderV2();
        }

        var cx = _classnames2['default'];
        var linkClasses = {
            'm-link-list--link': true,
            'menu-link': true,
            'google-collapse': true,
            'c-white': this.props.useWhite ? true : false,
            'c-ashen': this.props.useWhite ? false : true,
            'hc-cerulean': this.props.useWhite ? false : true,
            'hc-warm-chinchilla': this.props.useWhite ? true : false,
            'show-for-medium-up': true
        };

        var mobileMenuIconClasses = {
            'm-link-list--menu-link-mobile-icon': true,
            'c-white': this.props.useWhite ? true : false,
            'c-ashen': this.props.useWhite ? false : true
        };

        var topBarMenuLinks = topBarMenuLinkDataSource.map(function (topBarMenuLink, i) {
            return _react2['default'].createElement(_topBarMenuLink2['default'], {
                key: i,
                componentName: topBarMenuLink.componentName ? topBarMenuLink.componentName : '',
                linkOptions: topBarMenuLink.options,
                linkOverrideColors: topBarMenuLink.linkOverrideColors,
                useWhite: this.props.useWhite,
                linkText: topBarMenuLink.text,
                linkUrl: topBarMenuLink.url,
                pageToHighLight: this.props.pageToHighLight ? this.props.pageToHighLight : '' });
        }.bind(this));

        var menuIfOpen;
        if (this.state.menuOpen) {
            menuIfOpen = _react2['default'].createElement(_dropDownMenu2['default'], {
                style: { right: 40 },
                dropDownMenuLinkData: this.props.dropDownMenuLinkData });
        }

        var menu = _react2['default'].createElement(
            'div',
            { className: 'm-link-list--link--container menu-container ' + (this.props.hideDropDownMenu ? 'is-hidden-on-large' : ''), onMouseEnter: this.openMenu, onMouseLeave: this.closeMenu },
            _react2['default'].createElement(
                'a',
                { href: 'javascript:;', className: cx(linkClasses), onClick: this.toggleMenu, tabIndex: '-1' },
                _react2['default'].createElement(
                    'span',
                    null,
                    'MENU',
                    _react2['default'].createElement(
                        'span',
                        { className: 'm-link-list--menu-arrow' },
                        '\u25BE'
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { onMouseEnter: this.setStateMousedOverDropDownMenuTrue, onMouseLeave: this.setStateMousedOverDropDownMenuFalse },
                menuIfOpen
            )
        );

        var signUpButton;
        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
            signUpButton = _react2['default'].createElement(_signupButton2['default'], {
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact,
                signupForm: this.props.signupForm,
                loginForm: this.props.loginForm,
                recoverPasswordForm: this.props.recoverPasswordForm,
                async: false
            });
        }
        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
            signUpButton = _react2['default'].createElement(_signupButton2['default'], {
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact,
                signupUrl: this.props.signupTargetUrl,
                useRegularLink: this.props.useRegularLink,
                loginForm: this.props.loginForm,
                recoverPasswordForm: this.props.recoverPasswordForm,
                signupForm: this.props.signupForm,
                async: false
            });
        }

        var logInButton;
        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
            logInButton = _react2['default'].createElement(_loginButton2['default'], {
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                emailAddress: this.props.loginEmailAddress,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm });
        }
        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
            logInButton = _react2['default'].createElement(_loginButton2['default'], {
                emailAddress: this.props.loginEmailAddress,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
                loginUrl: this.props.loginTargetUrl,
                headerText: this.props.loginHeaderText,
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                displayCaptcha: this.props.displayCaptcha,
                useRegularLink: this.props.useRegularLink,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm
            });
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-link-list small-9 columns text-center ' + (!this.props.isLogInButtonVisible && !this.props.isSignUpButtonVisible && this.props.hideDropDownMenu ? 'is-compact' : ''), 'data-equalizer-watch': true },
            menu,
            _react2['default'].createElement(
                'a',
                { href: 'javascript:;', className: 'toggle-nav m-link-list--menu-link-mobile' + (this.props.useWhite ? ' c-white hc-warm-chinchilla' : ' c-castle-rock hc-cerulean'), tabIndex: '-1' },
                _react2['default'].createElement('span', { className: cx(mobileMenuIconClasses) })
            ),
            logInButton,
            signUpButton,
            topBarMenuLinks
        );
    },
    renderV2: function renderV2() {

        var topBarMenuLinkDataSource = _topBarV.TOP_BAR_V2_EXPERIMENT_LINK_DATA;

        var topBarMenuLinks = topBarMenuLinkDataSource.map(function (topBarMenuLink, i) {
            return _react2['default'].createElement(_topBarMenuLink2['default'], {
                key: i,
                componentName: topBarMenuLink.componentName ? topBarMenuLink.componentName : '',
                linkOptions: topBarMenuLink.options,
                linkOverrideColors: topBarMenuLink.linkOverrideColors,
                useWhite: this.props.useWhite,
                linkText: topBarMenuLink.text,
                linkUrl: topBarMenuLink.url,
                pageToHighLight: this.props.pageToHighLight ? this.props.pageToHighLight : ''
            });
        }.bind(this));

        var signUpButton;
        if (this.props.isSignUpButtonVisible && this.props.googleOpenIdUrl) {
            signUpButton = _react2['default'].createElement(_signupButton2['default'], {
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact,
                signupUrl: this.props.signupTargetUrl,
                useRegularLink: this.props.useRegularLink,
                signupForm: this.props.signupForm,
                buttonText: 'SIGN UP FREE',
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm,
                async: false
            });
        }

        var logInButton;
        if (this.props.isLogInButtonVisible && this.props.googleOpenIdUrl) {
            logInButton = _react2['default'].createElement(_loginButton2['default'], {
                emailAddress: this.props.loginEmailAddress,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                useWhite: this.props.useWhite,
                useBlack: this.props.useBlack,
                isCompact: this.props.isCompact || this.props.hideDropDownMenu,
                loginUrl: this.props.loginTargetUrl,
                headerText: this.props.loginHeaderText,
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                displayCaptcha: this.props.displayCaptcha,
                useRegularLink: this.props.useRegularLink,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm,
                className: 'external-top-bar' });
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-link-list small-9 large-10 columns text-center ', 'data-equalizer-watch': true },
            logInButton,
            signUpButton,
            topBarMenuLinks
        );
    }
});

module.exports = TopBarMenu;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/index.jsx
 ** module id = 1026
 ** module chunks = 0
 **/